module.exports = __webpack_public_path__ + "img/zhunan.71643d26.png";